
import AppleMusicIcon from "./assets/appleMusic.svg";
import SpotifyIcon from "./assets/Spotify_Icon_RGB_Green.png";
import TidalIcon from "./assets/tidal_logo_black.png";
import YoutubeMusicIcon from "./assets/youtube-music-icon.png";
import YoutubeIcon from "./assets/youtube_social_icon_red.png";

import { Badge } from './catalyst/badge';


export const  getIconForTransfer = (type, isYoutubeMusic=false) => {
    if (type === "spotify") {
      return <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img  src={SpotifyIcon} style={{height:26}} alt="SpotifyIcon"/></span>
    }
    if (type === "tidal") {
      return <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img  src={TidalIcon} style={{height:24}} alt="TidalIcon"/></span>
    }
    if (type === "appleMusic") {
      return  <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={AppleMusicIcon} style={{height:24}} /></span>
    }
    if (type === "youtube") {
      if(isYoutubeMusic) {
        return  <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={YoutubeMusicIcon} style={{height:24}} /></span>
      }
      return  <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={YoutubeIcon} style={{height:23}} /></span>
    }
  }

  export const  getIconForTransferUI = (type, isYoutubeMusic) => {
    if (type === "spotify") {
      return <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img  src={require('./assets/Spotify_Icon_RGB_Green.png')} style={{height:26}} alt="SpotifyIcon"/></span>
    }
    if (type === "tidal") {
      return <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img  src={require('./assets/tidal_logo_black.png')} style={{height:24}} alt="TidalIcon"/></span>
    }
    if (type === "appleMusic") {
      return  (<span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={require('./assets/appleMusic.svg')} style={{height:24}} /></span>)
    }
    if (type === "youtube") {
      if(isYoutubeMusic) {
        return  <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={require('./assets/youtube-music-icon.png')} style={{height:24}} /></span>
      }
      return  <span style={{width:40, height:26, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><img src={require('./assets/youtube_social_icon_red.png')} style={{height:23}} /></span>
    }
  }

  export const getCaTypetoName = (type, isYoutubeMusic) => {
    switch (type) {
      case 'spotify':
        return 'Spotify';
      case 'appleMusic':
        return 'Apple Music';
      case 'youtube':
        if(isYoutubeMusic === true) {
          return "YouTube Music"
        }
        return 'YouTube';
      default:
        return 'Music account';
    }
  }


  export const getThumbnailUrlCleaned = (url, accountType) => {
    let thumbnail =""

    if(accountType === 'appleMusic' && "" != url) {
      thumbnail = url.replace("{w}", "48")
      thumbnail = thumbnail.replace("{h}", "48")
      return thumbnail
    }
    return url

  }


  export const getSyncRunStatusBadge = (syncRun) => {
    let color = "zinc"
    let message = "Unknown"
    if(syncRun.runStatus === "IN_PROGRESS") {
      color="lime"
      message = "in progress"
    }
    if(syncRun.runStatus === "COMPLETED_WITH_MISSING") {
      color="amber"
      message = "completed with missing"
    }
    if(syncRun.runStatus === "COMPLETED") {
      color="green"
      message = "completed"
    }
    if(syncRun.runStatus === "COMPLETED_REPLACED") {
      color="green"
      message = "completed and replaced"
    }
    if(syncRun.runStatus === "ERROR") {
      color="red"
      message = "error"
    }
    return (<Badge color={color}>{message}</Badge>)
  }



  export const getSyncStatusBadge = (sync) => {
    let color = "zinc"
    let message = "Unknown"
    if(sync.syncStatus === "CREATED") {
      color="zinc"
      message = "created"
    }
    if(sync.syncStatus === "INITIALIZING") {
      color="amber"
      message = "initating"
    }
    if(sync.syncStatus === "SCHEDULED") {
      color="green"
      message = "scheduled"
    }
    if(sync.syncStatus === "RUNNING") {
      color="green"
      message = "running"
    }
    if(sync.syncStatus === "DISCONNECTED") {
      color="red"
      message = "account disconnected"
    }
    if(sync.syncStatus === "PAUSED") {
      color="sky"
      message = "paused"
    }
    if(sync.syncStatus === "DELETED") {
      color="red"
      message = "deleted"
    }
    return (<Badge color={color}>{message}</Badge>)
  }